const options = {
    weekday: 'long',
    day: '2-digit',
    month: '2-digit',
    year: 'numeric',
};

const formattedDateId = new Intl.DateTimeFormat('id-ID', options).format(new Date());

const formattedDate = (date) => {
    if (date.length < 1) {
        return '';
    }

    return new Intl.DateTimeFormat('en-ID', options).format(new Date(date));
};

function convertDateTimezone(original = '') {
    return original.split('T')[0];
}

function convertToJakartaTime(isoDate) {
    const date = new Date(isoDate);
    const jakartaTime = new Intl.DateTimeFormat('en-ID', {
        timeZone: 'Asia/Jakarta',
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
        hour: '2-digit',
        minute: '2-digit',
        second: '2-digit',
        hour12: false,
    }).format(date);

    return jakartaTime;
}

const formattedDate2 = (date) => {
    if (date.length < 1) {
        return '';
    }

    return new Intl.DateTimeFormat('en-ID').format(new Date(date));
};

function formattedDate3(dateString) {
    const dateVal = String(dateString || '');

    if (typeof dateString === 'string' && dateVal.length > 0) {
        const splitDate = dateVal.split('T');
        const result = splitDate.length > 0 ? splitDate[0] : '';
        const resultDate = result.split('-');

        let year = resultDate[0];
        let month = resultDate[1];
        let day = resultDate[2];

        // Mengembalikan tanggal dalam format YYYY-MM-DD
        return `${year}-${month}-${day}`;
    }

    let date = new Date(dateString);
    let year = date.getFullYear();
    let month = (date.getMonth() + 1).toString().padStart(2, '0');
    let day = date.getDate().toString().padStart(2, '0');

    return `${year}-${month}-${day}`;
}

const formattedDateTime = (date) => {
    if (date.length < 1) {
        return '';
    }

    const options = {
        weekday: 'long', // untuk mendapatkan hari dalam seminggu
        day: '2-digit',
        month: '2-digit',
        year: 'numeric',
        hour: '2-digit',
        minute: '2-digit',
        hour12: false, // menggunakan format 24 jam
        timeZone: 'Asia/Jakarta', // pastikan menggunakan zona waktu yang sesuai
    };

    return new Intl.DateTimeFormat('en-ID', options).format(new Date(date));
};

const getTime = () => {
    const date = new Date();
    const hours = date.getHours();
    const minutes = date.getMinutes();
    const second = date.getSeconds();

    return `${hours < 10 ? `0${hours}` : hours}:${minutes < 10 ? `0${minutes}` : minutes}:${second < 10 ? `0${second}` : second}`;
};

const formattedBillDateOrder = (date = new Date()) => {
    // Get the date parts in Jakarta timezone
    const formatter = new Intl.DateTimeFormat('en-US', {
        timeZone: 'Asia/Jakarta',
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
        hour: '2-digit',
        minute: '2-digit',
        second: '2-digit',
        hour12: false,
    });

    const parts = formatter.formatToParts(date);
    const values = Object.fromEntries(parts.map(({ type, value }) => [type, value]));

    // Create ISO string with Jakarta offset
    return `${values.year}-${values.month}-${values.day}T${values.hour}:${values.minute}:${values.second}+07:00`;
};

const getTimeOpenDuration = (timeOpen = '') => {
    const now = new Date();
    const [openHours, openMinutes] = timeOpen.split(':').map(Number);

    // Buat objek Date untuk waktu saat ini dan waktu open
    const openTime = new Date(now);
    openTime.setHours(openHours, openMinutes, 0, 0);

    // Hitung selisih waktu dalam milidetik
    const diff = now - openTime;

    // Konversi selisih waktu ke jam dan menit
    const hours = Math.floor(diff / (1000 * 60 * 60));
    const minutes = Math.floor((diff % (1000 * 60 * 60)) / (1000 * 60));
    const seconds = Math.floor((diff % (1000 * 60)) / 1000);

    // Format hasilnya menjadi 00:05
    const formattedHours = String(hours > -1 ? hours : hours * -1).padStart(2, '0');
    const formattedMinutes = String(minutes > -1 ? minutes : minutes * -1).padStart(2, '0');
    const formattedSeconds = String(seconds > -1 ? seconds : seconds * -1).padStart(2, '0');

    return `${formattedHours}:${formattedMinutes}:${formattedSeconds}`;
};

const formattedTime = (date = new Date(), locale = 'id-ID') => {
    const formatter = new Intl.DateTimeFormat(locale, {
        hour: '2-digit',
        minute: '2-digit',
        hour12: false,
        timeZoneName: 'short',
    });
    return formatter.format(date);
};

export { convertDateTimezone, convertToJakartaTime, formattedBillDateOrder, formattedDate, formattedDate2, formattedDate3, formattedDateId, formattedDateTime, formattedTime, getTime, getTimeOpenDuration };
